var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9209 1.56484C17.9206 1.96253 17.7623 2.34381 17.4809 2.62484L9.80895 10.2968C9.57673 10.529 9.39252 10.8046 9.26684 11.108C9.14117 11.4113 9.07648 11.7365 9.07648 12.0648C9.07648 12.3932 9.14117 12.7183 9.26684 13.0217C9.39252 13.3251 9.57673 13.6007 9.80895 13.8328L17.4709 21.4948C17.7442 21.7777 17.8954 22.1567 17.892 22.5499C17.8885 22.9432 17.7308 23.3195 17.4527 23.5976C17.1746 23.8757 16.7983 24.0334 16.405 24.0369C16.0118 24.0403 15.6329 23.8891 15.3499 23.6158L7.68795 15.9598C6.65771 14.9276 6.0791 13.5288 6.0791 12.0703C6.0791 10.6119 6.65771 9.21311 7.68795 8.18085L15.3599 0.503844C15.5697 0.293928 15.8371 0.150957 16.1281 0.0930232C16.4192 0.0350891 16.7209 0.0647952 16.9951 0.178383C17.2692 0.29197 17.5036 0.484334 17.6684 0.731133C17.8332 0.977931 17.9211 1.26807 17.9209 1.56484Z",
    fill: "#6179A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0598679)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.c0a84d075258627c5bc3e7feba08edde.svg";
export { ForwardRef as ReactComponent };